import { AlignmentTransform } from "@/modes/alignment-modes-commons/alignment-transform";
import { TwoPointsPairsAlignmentAnchorPositions } from "@/modes/alignment-modes-commons/compute-split-screen-alignment";
import {
  AlignmentViewLayout,
  SplitDirection,
} from "@/store/modes/alignment-ui-types";
import { RootState } from "@/store/store";
import { GUID } from "@faro-lotv/foundation";

/**
 * @param state  Current state
 * @returns ID of reference sheet used in current session of sheet-to-sheet alignment
 */
export function selectReferenceForSheetToSheetAlignment(
  state: RootState,
): GUID | undefined {
  return state.sheetToSheetAlignmentMode.referenceSheetId;
}

/**
 * @param state  Current state
 * @returns ID of aligned sheet used in current session of sheet-to-sheet alignment
 */
export function selectAlignedSheetForSheetToSheetAlignment(
  state: RootState,
): GUID | undefined {
  return state.sheetToSheetAlignmentMode.alignedSheetId;
}

/**
 * @param state  Current state
 * @returns  anchor positions in split screen for sheet-to-sheet alignment
 */
export function selectAnchorPositionsForSheetToSheetAlignment(
  state: RootState,
): TwoPointsPairsAlignmentAnchorPositions {
  return state.sheetToSheetAlignmentMode.alignmentAnchorPositions;
}

/**
 * @param state  Current state
 * @returns incremental sheet-to-sheet transform in CS of previous pose or undefined if position/scale was not modified
 */
export function selectIncrementalSheetTransformForSheetToSheetAlignment(
  state: RootState,
): AlignmentTransform | undefined {
  return state.sheetToSheetAlignmentMode.incrementalTransform;
}

/**
 * @param state  Current state
 * @returns the current sheet-to-sheet alignment screen layout
 */
export function selectLayoutForSheetToSheetAlignment(
  state: RootState,
): AlignmentViewLayout {
  return state.sheetToSheetAlignmentMode.alignmentLayout;
}

/**
 * @param state  Current state
 * @returns the current alignment screen split direction
 */
export function selectSplitDirectionForSheetToSheetAlignment(
  state: RootState,
): SplitDirection {
  return state.sheetToSheetAlignmentMode.splitDirection;
}
